import React from 'react';
import Button from '@mui/material/Button';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { useAppDispatch, useAppSelector } from 'redux/hooks/reduxHooks';
import { selectAlertDialogInfo } from 'redux/selectors/selectors';
import { closeAlertDialog } from 'redux/slices/modals/modals.slice';
import { smallModalPadding, smallModalClosePosition } from 'shared/constants/mui-constants';
import { ModalContainer } from '../ModalContainer';

export const AlertDialog: React.FC = () => {
  const { isOpen, data } = useAppSelector(selectAlertDialogInfo);

  const dispatch = useAppDispatch();
  const handleClose = () => dispatch(closeAlertDialog());

  if (!isOpen && !data) return null;

  return (
    <ModalContainer
      isOpen={isOpen}
      onClose={handleClose}
      padding={smallModalPadding}
      closeIconPosition={smallModalClosePosition}
    >
      <Typography
        variant="h2"
        sx={{ color: 'primary.main', textTransform: 'none', pb: '8px', textAlign: 'left' }}
      >
        {data.title}
      </Typography>
      <Typography variant="subtitle1" color="primary.main">
        {data.text}
      </Typography>
      <Stack
        direction="row"
        width="100%"
        sx={{
          pt: { lg: '32px', md: '24px', sm: '24px', xs: '24px' },
          columnGap: { md: '25px', sm: '6px', xs: '6px' },
        }}
      >
        <Button
          variant="autoSize"
          onClick={() => {
            data.сonsentCallback();
            handleClose();
          }}
          sx={{
            width: '100%',
          }}
        >
          {data.сonsentText}
        </Button>
        <Button
          variant="defaultLight"
          onClick={() => {
            if (data.dissentCallback) data.dissentCallback();
            handleClose();
          }}
          sx={{
            width: '100%',
          }}
        >
          {data.dissentText}
        </Button>
      </Stack>
    </ModalContainer>
  );
};
